
import cart from "../components/cart/cart.vue"

export default {
  name: "Cart",
  components: {
    cart
  },
  data() {
    return {}
  },
  mounted() {
    document.title = this.$t("pageTitle.cart")
  }
}
